<!-- use tags -->

import Layout1 from "../../src/routes/_index/+layout.marko";
import Layout2 from "../../src/routes/_index/components/+layout.marko";
import Page from "../../src/routes/_index/components/button-link/css+page.marko";

<Layout1>
	<Layout2>
		<Page/>
	</>
</>
